import { css, keyframes } from 'styled-components';

export const rotate = keyframes`
  from {
      transform: rotate(0deg);
  }

  to {
      transform: rotate(360deg);
  }
`;

export const fade = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
  }
`;

export const pop = keyframes`
  50% {
    transform: scale(1.5, 1.5);
  }
  100% {
    transform: scale(1, 1);
  }
`;

export const popping = css`
    animation: ${pop} 0.2s ease-in-out 1;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export const loading = css`
    animation: ${rotate} 1.5s linear infinite;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

export const fading = css`
    animation: ${fade} 0.3s ease 0s 1 normal none running;

    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;

const MESSAGE_HIGHLIGHT_DURATION_MS = 3500;
const MESSAGE_HIGHLIGHT_FADE_RATIO = 0.48;

const blinkBackground = (color: string) => keyframes`
    0% {
        background-color: transparent;
    }
    28% {
        background-color: ${color};
    }
    ${MESSAGE_HIGHLIGHT_FADE_RATIO * 100}% {
        background-color: ${color};
    }
    100% {
        background-color: transparent;
    }
`;

export const blinkingBackground = (duration: string = `${MESSAGE_HIGHLIGHT_DURATION_MS}ms`) => css`
    animation: ${props => blinkBackground(props.theme.root.colors.basicColors['8%'])} ${duration} ease-in-out;
    @media (prefers-reduced-motion: reduce) {
        animation: none;
    }
`;
